import Store from "@/shared/global-store";
import axios from "axios";

const Axios = axios.create({
  maxRedirects: 0,
  validateStatus: function (status) {
    return status >= 200 && status < 302;
  },
});

Axios.interceptors.response.use(
  function (response) {
    const responseURL = response.request.responseURL as string;
    if (responseURL.toLocaleLowerCase().indexOf("/spa/login?") != -1) {
      window.location.href = responseURL;
    }
    return response;
  },
  async function (error) {
    if (!error.response) {
      const msg = "Falha de conexão com o servidor.";
      Store.setMsgAlert(msg);
      return Promise.reject(msg);
    }

    if (error.response.status === 401) {
      const query = { returnUrl: window.location.href };
      window.location.href =
        "/spa/login?" + new URLSearchParams(query).toString();
      return Promise.reject("Sessão expirada");
    }

    const status = error.response.status;
    let payload: unknown = error.response.data;
    if (payload instanceof Blob) {
      const text = await payload.text();
      try {
        payload = JSON.parse(text);
      } catch {
        payload = text;
      }
    }

    let msg: string | undefined;
    if (typeof payload === "string") {
      msg = payload.length > 0 && payload.length < 200 ? payload : undefined;
    } else if (payload && typeof payload === "object") {
      const p = payload as Record<string, unknown>;
      msg = (p.error_description || p.exceptionMessage || p.detail || p.title || p.message) as string | undefined;
    }

    if (!msg) {
      msg = `Erro inesperado (${status} ${error.response.statusText || ""}).`.trim();
    }

    Store.setMsgAlert(msg);
    return Promise.reject(msg);
  }
);

export default Axios;
